<div class="alert-list-container">
  <div class="alert-list-container-icon-col">
    <mat-icon svgIcon="warning-icon"></mat-icon>
  </div>
  <div class="alert-list-container-info-col">
    <!-- Main error message -->
    <ng-content select="[miq-alert-list-description]"></ng-content>

    <!-- One block by entity -->
    <div *ngFor="let errorData of alertList" class="alert-list-container-errors-container">
      <div *ngIf="errorData.errorMap" class="alert-list-container-errors-container-error-block">
        <div *ngIf="errorData.entity" class="alert-list-container-errors-container-entityName">
          {{ errorData.entity | titlecase }}: &nbsp;
        </div>
        <div *ngFor="let error of errorData.errorMap | keyvalue; last as last">
          <div class="alert-list-container-errors-container-entity-link">
            <miq-goes-to-record targetAnchor="_blank" [id]="error.key" [type]="errorData.linkEntityTargetType">
              #{{ error.key }}
            </miq-goes-to-record>
            <span *ngIf="!last">,&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
